import { createSelector } from '@reduxjs/toolkit'

import type { JackpotSelectorParams, ProviderJackpot } from './types'
import type { ReduxState } from 'src/store/types'

const getProvidersJackpotsSelector = (state: ReduxState) =>
  (state.providersJackpots?.jackpots ?? []) as ProviderJackpot[]

export const getProvidersJackpotsIsLoadedSelector = (state: ReduxState) => state.providersJackpots?.isLoaded ?? false

export const getProvidersJackpotAmountSelector = createSelector(
  getProvidersJackpotsSelector,
  (_: ReduxState, params: JackpotSelectorParams) => params,
  (jackpots, { supplier, currency }) => {
    if (!supplier) {
      return null
    }

    const jackpot = jackpots.find((item) => item.supplier === supplier && item.currency === currency)

    return jackpot?.amount ?? null
  },
)
